import { CustomError } from "@skv/core";
import { FavouriteResult, State } from "./types";

export const favouritesReducer = (
  state: State = {
    loading: false,
    error: false,
    data: null,
  },
  action: Action
): State => {
  switch (action.type) {
    case "FAVOURITES_RESULT:FETCH:START":
      return {
        ...state,
        loading: true,
        error: false,
      };
    case "FAVOURITES_RESULT:FETCH:END":
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case "FAVOURITES_RESULT:FETCH:ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

type Action =
  | {
      type: "FAVOURITES_RESULT:FETCH:START";
    }
  | {
      type: "FAVOURITES_RESULT:FETCH:END";
      payload: {
        data: FavouriteResult;
      };
    }
  | {
      type: "FAVOURITES_RESULT:FETCH:ERROR";
      payload: {
        error: CustomError;
      };
    };
